// extracted by mini-css-extract-plugin
export default {"allCategories":"allCategories_allCategories__OeC1g","allCategories__head":"allCategories_allCategories__head__lwoYx"};